import { render, staticRenderFns } from "./dataAnalysisRecord.vue?vue&type=template&id=80770112&scoped=true&"
import script from "./dataAnalysisRecord.vue?vue&type=script&lang=js&"
export * from "./dataAnalysisRecord.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysisRecord.vue?vue&type=style&index=0&id=80770112&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80770112",
  null
  
)

export default component.exports